
import { Component, Vue } from 'vue-property-decorator';
import TheSidebar from '@/components/TheSidebar.vue';
import TheHeader from '@/components/TheHeader.vue';

@Component({
  components: { TheHeader, TheSidebar },
})
export default class MainWrapper extends Vue {}
